import React, { useState, useEffect } from 'react'
import { Grid, Paper, Box, InputLabel, TextField, Button, TableContainer, Table, TableBody, TableHead, TableRow, TableCell } from "@mui/material"
import { styled } from '@mui/material/styles'
import * as actions from "../Common/actions"
import { toastError, toastSuccess, validateEmail } from '../../utils';
import moment from "moment"
import Pagination from '@mui/lab/Pagination';

const CssTextField = styled(TextField)({
    fontFamily: "'DM Sans', sans-serif",
    color: "#fff",
    '& label': {
        fontFamily: "'DM Sans', sans-serif"
    },
    '& label.Mui-focused': {
        color: "#000"
    },
    '& .MuiInput-underline:after': {
        borderBottomColor: 'red',
    },
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
        },
        '&:hover fieldset': {
        },
        '&.Mui-focused fieldset': {
            borderColor: '#10baa8',
            borderWidth: "1px"
        },
    },
});

const StyledSubmit = styled(Button)({
    fontFamily: "'DM Sans', sans-serif",
    backgroundColor: "green",
    fontSize: 14,
    height: 35,
    width: 150,
    borderColor: "#0597b2",
    margin: "auto",
    color: "white",
    textTransform: 'capitalize',
    '&:hover': {
        backgroundColor: "#1cb91c",
    }
});

function Invite(props) {

    const [invite, setInvite] = useState({
        email: '',
        name: '',
        sentBy: 'admin'
    })
    const [sentInvites, setSentInvites] = useState([])
    const [count, setCount] = useState(0)
    const [filters, setFilters] = useState({
        limit: 50,
        offset: 0,
        page: 1
    })

    useEffect(() => {
        ongetSentInvitationsAdmin(filters)
    }, [filters])

    const ongetSentInvitationsAdmin = (filters) => {
        props.setLoader(true)
        actions.getSentInvitationsAdmin(filters).then(res => {
            props.setLoader(false)
            setSentInvites(res.body)
            setCount(res.total)
        }).catch(err => {
            props.setLoader(false)
        })
    }

    const onPageChange = (event, page) => {
        const offset = (page - 1) * filters.limit
        setFilters({ ...filters, page, offset })
    }

    const onSubmitSendEmail = () => {
        if (!validateEmail(invite.email)) return toastError('Invalid Email.')
        if (!invite.name) return toastError('Name is required.')
        props.setLoader(true)
        actions.sendInvite(invite).then(res => {
            props.setLoader(false)
            toastSuccess(res.message)
            setInvite({ email: '', name: '' })
            ongetSentInvitationsAdmin(filters)
        }).catch(err => {
            props.setLoader(false)
            toastError(err.message)
        })
    }
    let totalPages = Math.ceil(Number(count) / 50)
    return (
        <Grid container>
            <Grid item xs={12} sm={6} md={5} style={{ margin: "auto" }}>
                <Paper>
                    <Box p={2}>
                        <Grid container className="bank-details-modal">
                            <Grid item xs={12}>
                                <Box p={1}>
                                    <InputLabel>Email</InputLabel>
                                    <CssTextField
                                        placeholder="Email"
                                        variant="outlined"
                                        size="small"
                                        value={invite.email}
                                        onChange={(e) => setInvite({ ...invite, email: e.target.value })}
                                        fullWidth
                                    />
                                </Box>
                            </Grid>
                            <Grid item xs={12}>
                                <Box p={1}>
                                    <InputLabel>Name</InputLabel>
                                    <CssTextField
                                        placeholder="Name"
                                        variant="outlined"
                                        size="small"
                                        value={invite.name}
                                        onChange={(e) => setInvite({ ...invite, name: e.target.value })}
                                        fullWidth
                                    />
                                </Box>
                            </Grid>

                            <Grid item xs={12} style={{ display: "flex", marginTop: 10 }}>
                                <StyledSubmit onClick={onSubmitSendEmail}>Send Invite</StyledSubmit>
                            </Grid>

                        </Grid>
                    </Box>
                </Paper>
            </Grid>
            <Grid item xs={12} style={{ marginTop: 20 }}>
                <div>
                    <h2 style={{ float: "right" }}>Total: {count}</h2>
                </div>
            </Grid>
            <Grid item xs={12} style={{ marginTop: 10 }}>
                <TableContainer component={Paper}>
                    <Table className="universal-table">
                        <TableHead>
                            <TableRow style={{ background: "linear-gradient(90deg, rgba(19,153,121,1) 0%, rgba(18,180,161,1) 45%, rgba(5,150,179,1) 100%)" }}>
                                <TableCell className="color-white">S.no</TableCell>
                                <TableCell className="color-white">Name</TableCell>
                                <TableCell className="color-white">Email</TableCell>
                                <TableCell className="color-white">Sent Date</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                sentInvites.length ? sentInvites.map((item, key) => {
                                    return <TableRow key={key}>
                                        <TableCell>{((filters.page - 1) * filters.limit) + (key + 1)}</TableCell>
                                        <TableCell>{item.name || '-'}</TableCell>
                                        <TableCell>{item.email || '-'}</TableCell>
                                        <TableCell>{(item.created_at && moment(item.created_at).format('DD/MM/yyyy')) || '-'}</TableCell>
                                    </TableRow>
                                }) : <TableRow>
                                    <TableCell colSpan="4" align="center">No Request Found.</TableCell>
                                </TableRow>
                            }
                        </TableBody>
                    </Table>
                    <Pagination count={totalPages} showFirstButton showLastButton onChange={onPageChange} page={filters.page || 0} />
                </TableContainer>
            </Grid>

        </Grid>
    )
}

export default Invite
